import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=24ac681c&scoped=true&"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=24ac681c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac681c",
  null
  
)

export default component.exports